var _ = require('lodash');
_.mixin(require('lodash-inflection'));
String.prototype.pluralize = function (amount) {
    if (amount === void 0) { amount = 0; }
    var str = this;
    return _.pluralize(str, amount);
};
export {};
